import { Injectable } from "@angular/core";
import { AjaxService } from "./ajax.service";
import * as _ from "underscore";

@Injectable()
export class StaticPageService {
  faQData: any;
  staticPageInfo={};
  constructor(private ajaxService: AjaxService) {}

  getFaqQuestionsAndCategory(lang?) {
    lang = this.ajaxService.getActualMappedLanguage(lang);
    return Promise.resolve(
      Promise.resolve(
        this.ajaxService.getFaqQuestionsAndCategory({
          lang: lang ? lang : "en",
        })
      )
    ).then((faqCatQAResponse) => {
      const FaQData = {
        FaQCatQA: faqCatQAResponse,
        FaQCatQAIndexedById:
          faqCatQAResponse && faqCatQAResponse["faq_categories"]
            ? _.indexBy(faqCatQAResponse["faq_categories"], "id")
            : {},
      };
      this.setFaqData(FaQData);
      return FaQData;
    });
  }

  setFaqData(faqCatQAResponse) {
    this.faQData = faqCatQAResponse;
  }
  getStaticPageData(langCode,url){
    return this.ajaxService.getStaticPage({ 'lang': langCode, 'urlPath': url })
  }
}

